<div class="content-wrapper min-h-[714px]">
    <div class="flex justify-between w-full px-9">
        <div class="flex flex-row mb-8">
            <button (click)="closeDetails()" class="w-fit  mr-4"><i
                    class="far fa-chevron-left text-white text-2xl"></i></button>
            <p class="text-white text-2xl">Ver línea telefónica: <span class="text-accent">{{ line.telefono }}</span>
            </p>
        </div>
        <app-accent-button *ngIf="!isEdit" class="h-10" text="Editar" icon="fa-regular fa-pen-to-square mr-2"
            [selected]="true" (click)="editLine()"></app-accent-button>
        <div *ngIf="isEdit" class="flex flex-row gap-4">

            <app-accent-button class="h-10" text="Descartar" icon="fa-regular fa-xmark mr-2" [selected]="false"
                (click)="cancelEdit()"></app-accent-button>
            <app-accent-button class="h-10" text="Guardar" icon="fa-regular fa-floppy-disk mr-2" [selected]="true"
                (click)="saveLine()"></app-accent-button>
        </div>
    </div>
    <div class="w-full h-[1px] bg-tertiary"></div>
    <div class="p-9">
        <div class="flex flex-row mb-10">
            <div class="w-2/5">
                <p class="text-grey mb-2">Nº de línea</p>
                <p class="text-white">{{line.telefono}}</p>
            </div>
            <div class="w-2/5 flex gap-10">
                <div>
                    <p class="text-grey mb-2">Extensión</p>
                    <p *ngIf="!isEdit" class="text-white">{{ line.short_number || 'Sin número'}}</p>
                    <input type="text" *ngIf="isEdit" [(ngModel)]="shortNumber">
                </div>
                <div>
                    <p class="text-grey mb-2">URI</p>
                    <p *ngIf="!isEdit" class="text-white">{{ user.data.short_number_uri || 'Sin URI'}}</p>
                    <input type="text" *ngIf="isEdit" [(ngModel)]="uri">
                </div>
            </div>
        </div>
        <div class="flex flex-row mb-10">
            <div class="w-2/5">
                <p class="text-grey mb-2">Alias</p>
                <p *ngIf="!isEdit" class="text-white">{{line.alias || 'Sin alias'}}</p>
                <input type="text" *ngIf="isEdit" [(ngModel)]="alias">
            </div>
            <div class="w-2/5">
                <p class="text-grey mb-2">Grupo</p>
                <span
                    class="flex items-center justify-center text-white bg-dateBlueButton border border-accent rounded-button mr-10 py-2 px-4 w-fit h-9"
                    *ngIf="!isEdit && isGroup">{{group}}</span>
                <span
                    class="flex items-center justify-center text-white bg-transparent border border-accent rounded-button py-2 px-4 w-fit h-9"
                    *ngIf="!isEdit && isCustom || !isEdit && isProfile">{{group}}</span>
                <div class="custom-select" *ngIf="isEdit">
                    <i class="far fa-chevron-down icon"></i>
                    <mat-select [placeholder]="'Elegir'" [(value)]="selectedGroup"
                        (selectionChange)="onGroupChange($event.value)">
                        <mat-option *ngFor="let group of groups" [value]="group">{{ group.name }}</mat-option>
                        <mat-option value="sin grupo">SIN GRUPO</mat-option>
                    </mat-select>
                </div>
            </div>
        </div>
        <div class="flex flex-row mb-10">
            <div class="w-2/5">
                <p class="text-grey mb-2">Sim</p>
                <p class="text-white">{{lineSim }}</p>

            </div>
            <div class="w-2/5">
                <p class="text-grey mb-2">Perfil de configuración</p>
                <p *ngIf="!isEdit && !isCustom && !isProfile" class="text-accent"><i
                        class="fa-light fa-users mr-2"></i>{{profile}}</p>
                <span
                    class="flex items-center justify-center text-white bg-dateBlueButton border border-accent rounded-container mr-10 py-2 w-[188px] h-9"
                    *ngIf="!isEdit && isProfile">{{profile}}</span>
                <span
                    class="flex items-center justify-center text-white bg-transparent border border-accent rounded-container py-2 w-[188px] h-9"
                    *ngIf="!isEdit && isCustom"><i class="fa-light fa-sliders mr-2"></i>{{profile}}</span>
                <div class="custom-select" *ngIf="isEdit">
                    <i class="far fa-chevron-down icon"></i>
                    <mat-select [placeholder]="'Elegir'" [(value)]="selectedProfile"
                        (selectionChange)="onProfileChange($event.value)">
                        <mat-option *ngFor="let profile of profiles" [value]="profile">{{ profile.name }}</mat-option>
                        <mat-option value="heredado">Heredado de grupo</mat-option>
                    </mat-select>
                </div>
            </div>
        </div>
        <!-- <div class="flex flex-row mb-10">
            <div class="w-2/5">
                <p class="text-grey mb-2">Pin</p>
                <p class="text-white">{{sim.pin1 }}</p>

            </div>
            <div class="w-2/5">
                <p class="text-grey mb-2">Puk</p>
                <p class="text-white">{{sim.puk }}</p>
            </div>
        </div> -->
    </div>
</div>